import "./EmptyState.scss";

import { RocketIcon } from "../../../../components/icons";

const EmptyState: React.FC = () => {
  return (
    <div className="playground-empty-state">
      <RocketIcon size={48} />
      <h3>
        Enter a test prompt on the bottom to <br /> quickly try out CogCache
      </h3>
    </div>
  );
};

export { EmptyState };
